<template>
</template>

<script>
export default {
    name : 'TicketWidgetCSS',

    props : ['widget'],

    mounted() {
      if ( !this.widget || !this.widget.parameter ) {
        console.log('#13 TicketWidgetCSS mounted', this.widget, this);
        return;
      }

      var _script = document.createElement("style");
      _script.innerHTML = this.widget.parameter;
      document.body.appendChild( _script );
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ticket/TicketWidgetCSS.vue